module.exports = __webpack_public_path__ + "img/ics_f_check_circle.cd990fa2.svg";